import nodeApi from '../utils/nodeApiClient';

const dashboardApi = {
  getStats: () => nodeApi.get('/dashboard/stats'),
  getOverview: () => nodeApi.get('/dashboard/overview')
};

export default dashboardApi;
